// extracted by mini-css-extract-plugin
export default {"link":"fK-z","disabled":"gK-z"};